import {
  DeviceType,
  selectHMSMessages,
  selectLocalPeer,
  selectPeerCount,
  selectPeerScreenSharing,
  selectPeers,
  selectRoomStartTime,
  selectScreenShareByPeerID,
  useDevices,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
import ControlBar from "./ControlBar";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import EmojiPicker from "emoji-picker-react";
import Header from "./Header";
import HostVideoTile from "./HostVideoTile";
import RenderDeviceSettings from "Components/Popup/DeviceSettings/Container/RenderDeviceSettings";
import ScreenShareVideoPeers from "./ScreenShareVideoPeers";
import SendIcon from "@mui/icons-material/Send";
import VideoTile from "./VideoTile";
import { disableRoom, EndCallRinging, leaveCall } from "Config/API/action";
import moment from "moment-timezone";
import { statusOfRoom } from "Config/API/get";
import { storeVideoChatLinkAction } from "Redux/action/get.action";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useStopwatch } from "react-timer-hook";
import video from "Media/icons/video.png";

const isScreenShareEvent = (message) => {
  if (typeof message !== "string") return false;

  try {
    const parsedMessage = JSON.parse(message);
    return (
      parsedMessage?.type === "SCREEN_SHARE_STARTED" ||
      parsedMessage?.type === "SCREEN_SHARE_STOPPED"
    );
  } catch (error) {
    if (error instanceof SyntaxError) return false;
    throw error;
  }
};

const Room = ({ call_user }) => {
  const videoRef = React.useRef(null);
  const hmsActions = useHMSActions();
  const localPeer = useHMSStore(selectLocalPeer);
  const peers = useHMSStore(selectPeers);
  const count = useHMSStore(selectPeerCount);
  const presenter = useHMSStore(selectPeerScreenSharing);
  const allMessages = useHMSStore(selectHMSMessages);
  const roomStartTime = useHMSStore(selectRoomStartTime);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.authenticationReducer);
  const msRoom = useSelector((state) => state.storeVideoChatLinkReducer.name);
  const msToken = useSelector((state) => state.storeVideoChatLinkReducer.token);
  const from = useSelector((state) => state.storeVideoChatLinkReducer.from);
  const roomId = useSelector((state) => state.storeVideoChatLinkReducer.id);
  const token = localStorage.getItem("token");
  const screenshareVideoTrack = useHMSStore(
    selectScreenShareByPeerID(presenter?.id)
  );
  const { allDevices, selectedDeviceIDs, updateDevice } = useDevices();
  const [showSettings, setShowSettings] = useState(false);

  const refreshMediaDevices = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });
    stream.getTracks().forEach((track) => track.stop());
  };

  useEffect(() => {
    const handleDeviceChange = () => {
      refreshMediaDevices().catch(() => {});
    };
    navigator.mediaDevices?.addEventListener?.(
      "devicechange",
      handleDeviceChange
    );
    return () => {
      navigator.mediaDevices?.removeEventListener?.(
        "devicechange",
        handleDeviceChange
      );
    };
  }, []);
  const [showChat, setShowChat] = useState(false);
  const [containerWidth, setContainerWidth] = useState("100%");
  const [message, setMessage] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [mirrorVideo, setMirrorVideo] = useState(false);
  const { seconds, minutes, hours } = useStopwatch({ autoStart: true });
  const [tabUniqueId, setTabUniqueId] = useState("");
  const hostPeers = peers.filter(
    (peer) => peer.roleName?.toString() === "host"
  );
  const featuredPeers =
    hostPeers.length > 0 ? hostPeers : peers.slice(0, 1);
  // window.addEventListener("beforeunload", () => localStorage.setItem("HELLO BEFORE UNLOAD", 'value'));
  // window.addEventListener("onunload", () => localStorage.setItem("HELLO ONUNLOAD", 'value'));

  React.useEffect(() => {
    (async () => {
      if (videoRef.current && screenshareVideoTrack) {
        if (screenshareVideoTrack.enabled) {
          await hmsActions.attachVideo(
            screenshareVideoTrack.id,
            videoRef.current
          );
        } else {
          await hmsActions.detachVideo(
            screenshareVideoTrack.id,
            videoRef.current
          );
        }
      }
    })();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenshareVideoTrack]);
  const roomExpireTimer = useRef(null);
  const GRACE_PERIOD_MS = 8000; // 10 seconds grace period for initial joining

  const graceTimer = useRef(null);
  const [isStable, setIsStable] = useState(false);
  const hasLeftRef = useRef(false);
useEffect(() => {
  if (!call_user) return;

  if (!isStable) {
    console.log("⏳ Starting grace timer...");
    if (graceTimer.current) clearTimeout(graceTimer.current);

    graceTimer.current = setTimeout(() => {
      console.log("✅ Grace timer completed. Setting isStable = true");
      setIsStable(true);
    }, GRACE_PERIOD_MS);
  }

  return () => {
    if (graceTimer.current) clearTimeout(graceTimer.current);
  };
}, [call_user, isStable]);
useEffect(() => {
  if (!call_user || !isStable || count !== 1) return;

  const safelyLeave = async () => {
    if (hasLeftRef.current) return; // prevent re-entry
  hasLeftRef.current = true;
    try {
      console.log("🚪 Leaving room safely...");
      await hmsActions.leave();
      dispatch(storeVideoChatLinkAction(""));

      const duration = hours * 3600 + minutes * 60 + seconds;

      const res = await leaveCall(
        token,
        loggedInUser?.id,
        loggedInUser?.org_id,
        duration % 30,
        msRoom,
        "false",
        "true",
        moment().format("YYYY-MM-DD HH:mm:ss"),
        tabUniqueId,
        moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")
      );

      if (res?.status) {
        const disableRes = await disableRoom(token, msToken, msRoom);
        if (disableRes?.status) {
      
 toast("The other participant left. Room is closed now.", {
            type: "success",
          });
              
           navigate(from === "appointment" ? "/appointment" : "/chat");
        } else {
          toast(disableRes?.message || "Failed to disable room.", {
            type: "error",
          });
        }
      }
    } catch (err) {
      console.error("❌ Error during leave:", err);
      toast("Something went wrong while ending the call.", { type: "error" });
    }
  };

  safelyLeave();
}, [
  call_user,
  isStable,
  count,
  hmsActions,
  dispatch,
  hours,
  minutes,
  seconds,
  token,
  msToken,
  loggedInUser?.id,
  loggedInUser?.org_id,
  msRoom,
  tabUniqueId,
  roomStartTime,
  from,
  navigate
]);




  React.useEffect(() => {
    if (showChat?.toString() === "true") {
      setContainerWidth("70%");
    } else if (showChat?.toString() === "false") {
      setContainerWidth("100%");
    }
  }, [showChat]);

React.useEffect(() => {
  const checkAndAssignHost = async () => {
    try {
      const host = peers.filter((peer) => peer.roleName?.toString() === "host");

      if (host.length === 0 && peers[0]?.id) {
        await hmsActions.changeRoleOfPeer(peers[0].id, "host", true);
      }

      const res = await statusOfRoom(token, msToken, roomId);

      if (res?.status && res?.data && !res.data.enabled) {
        if (typeof hmsActions?.leave === "function") {
          await hmsActions.leave();
        }

        dispatch(storeVideoChatLinkAction(""));

        toast(
          "Room got Disabled as one of the Organization does not have enough balance",
          {
            type: "info",
          }
        );

        if (from === "appointment") {
          return navigate("/appointment");
        }
        navigate(-1);
      }

    } catch (error) {
      console.error("❌ Error in checkAndAssignHost effect:", error);
      // toast("Something went wrong while checking room status.", {
      //   type: "error",
      // });
    }
  };

  checkAndAssignHost();

  // Optional cleanup if needed in future
  return () => {
    // Add any abort controller or cleanup here if async calls need to be cancelled
  };
}, [count, peers, hmsActions, token, msToken, roomId, dispatch, navigate, from]);


  useEffect(() => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    setTabUniqueId(loggedInUser?.id?.toString().concat("-", result));
  }, []);

React.useEffect(() => {
  const checkCreditAndLeave = async () => {
    const duration = hours * 3600 + minutes * 60 + seconds;

    // Trigger only every 30 seconds after 30 seconds
    if (duration > 29 && duration % 30 === 0) {
      try {
        const res = await leaveCall(
          token,
          loggedInUser?.id,
          loggedInUser?.org_id,
          30,
          msRoom,
          "true",
          "true",
          "",
          tabUniqueId,
          moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")
        );

        if (res?.statusCode === 400) {
          if (typeof hmsActions?.leave === "function") {
            await hmsActions.leave();
          }

          dispatch(storeVideoChatLinkAction(""));
          toast("You don't have Enough balance to continue the Call.", {
            type: "info",
          });

          if (from === "appointment") return navigate("/appointment");
          navigate(-1);
        }

      } catch (error) {
        console.error("❌ Error while checking balance and leaving:", error);
        toast("Something went wrong while verifying call balance.", {
          type: "error",
        });
      }
    }
  };

  checkCreditAndLeave();

  // No cleanup needed since nothing async needs aborting
}, [seconds, minutes, hours, token, loggedInUser, msRoom, tabUniqueId, roomStartTime, hmsActions, dispatch, from, navigate]);


  const updateSettings = async (event, type) => {
    const deviceId = event?.target?.value;
    if (!deviceId || deviceId === "noData") return;

    const deviceTypeMap = {
      videoInput: DeviceType.videoInput,
      audioInput: DeviceType.audioInput,
      audioOutput: DeviceType.audioOutput,
    };
    const deviceType = deviceTypeMap[type];
    if (!deviceType) return;

    try {
      await updateDevice({ deviceId, deviceType });
    } catch (error) {
      console.error("Failed to switch device:", error);
      toast("Failed to switch device. Please try again.", { type: "error" });
    }
  };

  const formatTime = (item) => {
    const date = new Date(item);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinute = minutes < 10 ? `0${minutes}` : minutes;
    const time = `${hours}:${formattedMinute}`;
    return time;
  };

  const checkPermissions = async (msg) => {
    if (msg?.toString() === "setting") {
      try {
        await refreshMediaDevices();
      } catch (err) {
        if (err?.message?.toString() === "Permission denied") {
          toast(
            "Allow camera access in your browser to see all available cameras.",
            { type: "info" }
          );
        }
      }
      setShowSettings(true);
      return;
    }

    try {
      await refreshMediaDevices();
    } catch (err) {
      if (err?.message?.toString() === "Permission denied") {
        toast(
          "Enable video and audio access in your browser's access bar.",
          { type: "info" }
        );
      } else {
        toast(`${err?.message}`, { type: "info" });
      }
    }
  };

  return (
    <>
      <Header
        showChat={setShowChat}
        checkPermissions={checkPermissions}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        loggedInUser={loggedInUser}
        localPeer={localPeer}
        peers={peers}
        startTime={moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")}
        tabUniqueId={tabUniqueId}
      />
      <div style={{ width: "100%", height: "80%", display: "flex" }}>
        <div
          className="conference-section"
          style={{ width: `${containerWidth}` }}
        >
          {screenshareVideoTrack?.enabled ? (
            <div className="video-call-sharing-screen-container">
              <video
                ref={videoRef}
                autoPlay={true}
                playsInline
                muted={true}
                className="video-call-sharing-screen-video-section"
                style={{ backgroundColor: "transparent" }}
              ></video>
              <div className="video-call-sharing-screen-peers-section">
                {peers &&
                  peers?.map((peer, index) => {
                    return (
                      <ScreenShareVideoPeers
                        isLocal={false}
                        peer={peer}
                        key={index}
                        mirrorVideo={mirrorVideo}
                      />
                    );
                  })}
              </div>
              <ControlBar
                checkPermissions={checkPermissions}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                loggedInUser={loggedInUser}
                localPeer={localPeer}
                peers={peers}
                setMirrorVideo={setMirrorVideo}
                mirrorVideo={mirrorVideo}
                startTime={moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")}
                tabUniqueId={tabUniqueId}
              />
            </div>
          ) : count?.toString() === "1" ? (
            <>
              <div className="video-call-single-user-Container">
                {peers &&
                  peers.map((peer, index) => {
                    return (
                      <VideoTile
                        isLocal={false}
                        peer={peer}
                        key={index}
                        mirrorVideo={mirrorVideo}
                      />
                    );
                  })}
              </div>
              <ControlBar
                checkPermissions={checkPermissions}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                loggedInUser={loggedInUser}
                localPeer={localPeer}
                peers={peers}
                setMirrorVideo={setMirrorVideo}
                mirrorVideo={mirrorVideo}
                startTime={moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")}
                tabUniqueId={tabUniqueId}
              />
            </>
          ) : (
            <>
              {/* <div className="peers-container">
             
              {peers &&
                peers
                  //.filter((peer) => !peer.isLocal)
                  ?.map((peer, index) => {
                    return (
                      <VideoTile isLocal={false} peer={peer} key={index} />
                    );
                  })}
            </div> */}
              <div className="video-call-sharing-screen-container">
                <div className="video-call-sharing-screen-video-section">
                  {featuredPeers.map((peer) => (
                    <HostVideoTile
                      isLocal={false}
                      peer={peer}
                      key={peer.id}
                      mirrorVideo={mirrorVideo}
                      isHost={hostPeers.length > 0}
                    />
                  ))}
                </div>
                <div className="video-call-sharing-screen-peers-section">
                  {peers &&
                    peers
                      .filter(
                        (peer) =>
                          !featuredPeers.some(
                            (featuredPeer) => featuredPeer.id === peer.id
                          )
                      )
                      .map((peer, index) => {
                        return (
                          <>
                            <ScreenShareVideoPeers
                              isLocal={false}
                              peer={peer}
                              key={index}
                              mirrorVideo={mirrorVideo}
                            />
                          </>
                        );
                      })}
                </div>
              </div>
              <ControlBar
                checkPermissions={checkPermissions}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                loggedInUser={loggedInUser}
                localPeer={localPeer}
                peers={peers}
                setMirrorVideo={setMirrorVideo}
                mirrorVideo={mirrorVideo}
                startTime={moment(roomStartTime).format("YYYY-MM-DD HH:mm:ss")}
                tabUniqueId={tabUniqueId}
              />
            </>
          )}
        </div>
        {showChat && (
          <div className="room-chat-dialog">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 10px",
                alignItems: "center",
                width: "100%",
              }}
            >
              <h4
                style={{
                  fontWeight: 900,
                  fontSize: "18px",
                  marginTop: 0,
                  marginBottom: 0,
                }}
              >
                Meeting Chat
              </h4>
              <button
                className="chat-close-button"
                onClick={() => {
                  setShowChat(false);
                  setShowEmojiPicker(false);
                }}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>
            <div
              style={{
                width: "100%",
                height: "90%",
                overflow: "scroll",
                marginTop: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  width: "100%",
                  padding: "0px 10px",
                  alignItems: "center",
                }}
              >
                <img src={video} alt="video" height={20} width={30} />
                {formatTime(roomStartTime)}
                <span>Meeting Started</span>
              </div>
              {allMessages
                .filter((item) => !isScreenShareEvent(item?.message))
                .map((item) => (
                <div
                  style={{
                    marginTop: "25px",
                    marginBottom: "-15px",
                    padding: "10px 20px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 900,
                        fontSize: "18px",
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    >
                      {item?.senderName}
                    </h5>
                    <span
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    >
                      {formatTime(item?.time)}
                    </span>
                  </div>
                  <span style={{ marginTop: 2 }}>{item?.message}</span>
                </div>
                ))}
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: "0px 10px",
                flexDirection: "column",
              }}
            >
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  width: "100%",
                  height: "40px",
                  backgroundColor: "#1F1F1F",
                }}
                placeholder="Type a new message"
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "3px 7px",
                }}
              >
                <button
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  className="chat-close-button"
                >
                  <EmojiEmotionsIcon fontSize="small" />
                </button>
                <button
                  onClick={() => {
                    if (message.length > 0) {
                      hmsActions.sendBroadcastMessage(message);
                      setMessage("");
                      setShowEmojiPicker(false);
                    }
                  }}
                  className="chat-close-button"
                >
                  <SendIcon fontSize="small" />
                </button>
              </div>
            </div>
            {showEmojiPicker && (
              <EmojiPicker
                height="250%"
                width="100%"
                onEmojiClick={(e) => setMessage(message.concat(e.emoji))}
                theme="dark"
                searchDisabled={true}
              />
            )}
          </div>
        )}
      </div>
      <RenderDeviceSettings
        showSettings={showSettings}
        allDevices={allDevices}
        setShowSettings={setShowSettings}
        updateSettings={updateSettings}
        selectedDeviceIDs={selectedDeviceIDs}
      />
    </>
  );
};

export default Room;
